import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router";
import { Switch } from "react-router-dom";
import { NOT_FOUND } from "../../constants/routes";
import NotFound from "../../components/NotFound";

const NotFoundHandleSwitch = ({
  children
}) => /*#__PURE__*/React.createElement(Switch, null, children, /*#__PURE__*/React.createElement(Route, {
  exact: true,
  strict: true,
  path: NOT_FOUND,
  component: NotFound
}), /*#__PURE__*/React.createElement(Redirect, {
  to: NOT_FOUND
}));

NotFoundHandleSwitch.propTypes = {
  children: PropTypes.node
};
export default NotFoundHandleSwitch;